import { courseCacheTags } from './courseCacheTags'
import { enhancedApi as generatedCyclesApi } from './cycles'
import { cycleCacheTags } from './cycleCacheTags'

// The generator emits no cache tags, so they are applied here rather than patched back into
// `cycles.ts` after every run, which is what used to drift. Import these hooks from this module,
// never from `./cycles`, or the tags are missing. Applied in two passes rather than one merged
// object so neither policy can silently overwrite a key of the other.
export const cyclesApi = generatedCyclesApi
  .enhanceEndpoints({ endpoints: cycleCacheTags })
  .enhanceEndpoints({ endpoints: courseCacheTags })

export const {
  useListTrainingCyclesQuery,
  useListTenantTrainingCyclesQuery,
  useGetTrainingCycleQuery,
  useCreateTrainingCycleMutation,
  useUpdateTrainingCycleMutation,
  useDeleteTrainingCycleMutation,
  useListEnrollmentsQuery,
  useLazyListEnrollmentsQuery,
  useListEnrollmentFilterOptionsQuery,
  useListEnrollmentGroupOptionsQuery,
  usePreviewEnrollmentGroupsQuery,
  useCreateEnrollmentsMutation,
  useCreateEnrollmentsBatchMutation,
  useRemoveEnrollmentsMutation,
  useRemoveEnrollmentsBatchMutation,
  useForceCompleteEnrollmentMutation,
  usePreviewTrainingCycleNextNotificationQuery,
  usePreviewNewTrainingCycleNextNotificationQuery,
  useSendCycleReminderMutation,
  useListTrainingCycleEmailsQuery,
  useSaveTrainingCycleEmailMutation,
  useResetTrainingCycleEmailMutation,
  useResetTrainingCycleEmailLanguageMutation,
  useExportTrainingCycleRecordsPdfMutation,
  useExportTrainingRecordsCsvMutation,
  useExportGlobalTrainingRecordsCsvMutation,
  useGetMyTrainingRecordsExportStatusQuery,
  useListTenantCoursesQuery,
  useListTenantCourseVariantsQuery,
  useGetTenantCourseLanguagesQuery,
  useGetTenantCourseQuery,
  useGetTrainingRecordsCsvExportStatusQuery,
} = cyclesApi
export { useListEnrollmentGroupOptionPagesInfiniteQuery } from './enrollmentGroupOptions'
export const { usePrefetch: useCyclesPrefetch } = cyclesApi
